import { AvailableVegrupper, BruksklasserSpesialTransport, BruksklasseSpesialTransport, useRouteSettings, useRouteSettingsActions, Veggruppe } from "../../stores/RouteSettingsStore";
import { CheckboxInput } from "../common/CheckboxInput";
import { SelectInput } from "../common/SelectInput";

export default function BruksklasseSpesialTransportSettings() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();
    
    return (
        <>
            {routeSettings.routeType === "bruksklasseSpesialTransport" && 
            <>
                <SelectInput<BruksklasseSpesialTransport> 
                    allowedValues={BruksklasserSpesialTransport}
                    label="Bruksklase spesialtransport" 
                    value={routeSettings.bruksklasseNormalTransport}
                    onChange={(value:BruksklasseSpesialTransport) => {setRouteSettings({...routeSettings, bruksklasseSpesialTransport: value})}}
                />
                <SelectInput<Veggruppe>
                    allowedValues={AvailableVegrupper}
                    label="Veggruppe"
                    value={routeSettings.veggruppe}
                    onChange={(value: Veggruppe) => {setRouteSettings({...routeSettings, veggruppe: value})}}
                />
                <CheckboxInput
                    label="Inkluder veggruppe 'Ikke'"
                    value={routeSettings.includeVeggruppeIkke}
                    onChange={(value:boolean) => {setRouteSettings({...routeSettings, includeVeggruppeIkke: value})}}
                />                
            </>
            }
        </>
    )
}